export default {
  langType: 'zh_tw',
  langName: '繁體中文',
  productName: '先知命局',
  slogan: '先知命局洞悉人生，先人一步知命用命',
  more: '瞭解更多',
  care: '關注我們',
  contact: '聯繫我們',
  copy: '複製成功',
  agreement: '服務協議',
  policy: '隱私政策',
  company: '公司：SEER ONNET PTE. LTD.',
  // 老師名字
  林鹤: '林鶴',
  易烊枫燧: '易烊楓燧',
  法銘道長: '法銘道長',
  赵振鸿: '趙振鴻',
  道元: '道元',
  // 老師標籤
  实战派: '實戰派',
  传道者: '傳道者',
  执法者: '執法者',
  演术师: '演術者',
  表演者: '演術者',
  联结者: '聯結者',
  // 老師描述
  日常命运的解构者: '日常命運的解構者',
  心性修行的引领者: '心性修證的引領者',
  幽冥因果的沟通者: '幽冥因果的溝通者',
  现实成就的缔造者: '現實成就的架構師',
  古今智慧的翻译师: '古今智慧的轉譯師',
  // 技能標籤
  四柱八字: '四柱八字',
  紫微斗数: '紫微斗數',
  掌面相: '掌面相',
  玄空风水: '玄空風水',
  环境风水: '環境風水',
  梅花易数: '梅花易數',
  手相面相: '手相面相',
  天眼通: '天眼通',
  六壬术法: '六壬術法',
  灵修导师: '靈修導師',
  奇门遁甲: '奇門遁甲',
  数字能量学: '數字能量學',
  奇门术法: '奇門術法',
  小六壬: '小六壬',
  高端风水布局: '高端風水佈局',
  八字命理: '八字命理',
  风水堪舆: '風水堪輿',
  铁板神数: '鐵板神數',
  // 學院介紹
  academyIntro:
    '歡迎來到《超能力學院》，一所跨越現實與未知的玄學競技學院。《超能力學院》是一個由楓燧、法銘、道元、振鴻四位玄學導師聯合發起，匯聚世界各地多位名師，涵蓋八字、風水、神通、薩滿、魔法等東西方學術，旨在為用戶提供豐富、專業且值得信賴的命運指導服務的機構。',
  // 學院特色
  academyFeature:
    '他們是超能力領域的頂尖強者，更是因材施教的啓蒙大師\n\n能解鎖你的潛力上限，能定製專屬修煉路徑，能帶你突破能力瓶頸！\n\n學院的亮點從不是噱頭，而是每位導師用實力兌現的 "超能力成長承諾"！',
  recordUserComment:
    '本人在31/12/2024還了一半受生債後，這10個月都有少許好轉，例如我們從香港搬來澳洲，能夠找到一間合適的屋，人也開心左，因為遠離香港家人的是是非非。另外，十年前在澳洲其他地區買了一間屋，但地點不理想，放賣了好幾年都未能成功，但早幾個月有買家岀價購買，雖然蝕少少但起碼賣岀。現在希望其他在香港和外地的物業都可以順利買岀🙏🏼😃',
  // 數據統計
  recordUserCount: '20',
  recordUserCountHighlight: '萬+',
  recordUserCountDesc: '真實用戶',
  recordAccuracy: '98.20%',
  recordAccuracyHighlight: '準確率',
  recordAccuracyDesc: '來自我們的客戶評價',
  recordScore: '4.8/5',
  recordScoreHighlight: '星',
  recordScoreDesc: '好評平均分',
  recordExpertCount: '100',
  recordExpertCountHighlight: '+',
  recordExpertCountDesc: '專業老師團隊',
  // 視頻相關
  '《超能力学院》第一季': '《超能力學院》第一季',
  videoTitle1:
    '【預告】全球首檔玄學選秀綜藝《超能力學院》震撼來襲！三位實力導師坐鎮，助力15位學員登頂 "玄學巔峰"！',
  videoTitle2:
    '超能力學院第二集：薩滿Leelay戳中催淚往事，梁思浩痛哭！Mx現場增財運，猜中彩票號碼！楓燧羅三梓同門精彩對決！',
  videoTitle3:
    '超能力學院第一集：驚悚海選日！Ives生吞香燭嚇翻全場！女巫海諾追星成功，但被競爭對手下黑手？祖師爺顯靈相助，麟龍當场跪哭！',
  videoTitle4: '超能力學院·第四集：海選日全員被下咒，幕後黑手竟然是他！15進9，戰隊成立，正式開學！',
  videoSeasonIntro:
    '歡迎來到《超能力學院》\n一所跨越現實與未知的玄學競技學院。\n15位術法新星、3位玄學導師，\n在真實競技中挑戰命運、覺醒潛能。\n這裡沒有劇本，只有考驗。\n他們要面對的不只是對手，\n還有自己的內心、未知的恐懼、隱藏的力量。\n每一次試煉，都是命運的拐點。\n每一場對決，都是術法與信念的較量。\n《超能力學院》———開啟屬於你的覺醒之門。',
  followYouTube: '關注《超能力學院》YouTube',
  // 服務相關
  '看命盘/看八字': '看命盤/看八字',
  service1Feature1: '正統道教背景，正壹派弟子',
  service1Feature2: '20年實戰經驗，已服務10000+學員',
  service1Feature3: '線上1對1溝通，30分鐘出初步解析',
  service1Description:
    '精準八字測算服務,透過八字命盤、個人資料分析，提供量身定制的命理咨詢，以改善個人運勢和命運。服務涵蓋姻緣、事業、財運等方面。',
  法事祈福: '法事祈福',
  service2Feature1: '正壹派正規法事流程，附法事文疏存根',
  service2Feature2: '法事前提供需求溝通，事後給護持建議',
  service2Feature3: '支持香港現場參與/線上視頻回看',
  service2Description:
    '正統道教法事祈福：針對冤親債主化解、家宅淨宅除煞、事業財運增益、健康平安祈福等需求，由高功道長主持正規法事，護佑運勢順暢。',
  起名改名: '起名改名',
  service3Feature1: '八字五行精準適配，拒絕隨機選字',
  service3Feature2: '3套命名方案+字義解析，可挑選調整',
  service3Feature3: '公司命名匹配行業屬性，助力開局順利',
  service3Description:
    '開運命名服務：根據玄學五行、八字喜忌與風水納福原理，提供嬰兒、個人、公司機構的量身定制取名/改名方案，助運勢提升、避兇趨吉。',
  风水布局: '風水佈局',
  service4Feature1: '上門勘測+現場標煞，拒絕線上盲判',
  service4Feature2: '提供家具擺放、掛飾選用等可落地方案',
  service4Feature3: '商鋪布局適配客流動線，助推業績提升',
  service4Description:
    '空間能量重設：依九宮飛星與命理五行，上門勘測商鋪、辦公室、家居空間,精準調和藏風聚氣格局，化解煞位、旺財旺人丁。',
  课程讲座: '課程講座',
  service5Feature1: '理論+案例分析，不講“空泛理論”',
  service5Feature2: '課後1對1答疑+學習群，避免學完就忘',
  service5Feature3: '課程可反復觀看，持續學習',
  service5Description:
    '玄學實戰課程學習：針對八字入門、風水基礎、擇日要訣等內容，由20年經驗導師線上直播授課+線下實操指導，助學員掌握實用玄學技能。',
  择日: '擇日',
  service6Feature1: '依個人/企業八字定制，拒絕通用黃歷',
  service6Feature2: '3套吉日建議+吉時說明，可自由挑選',
  service6Feature3: '附簡易開運注意事項+行事宜忌說明',
  service6Description:
    '依據天干地支、陰陽五行、紫白飛星等原理,為結婚開張、入伙動土、開光祭祀、簽約出行等重大事宜甄選良辰吉時，助你趨吉避凶、事事順遂。',
  加whatsapp获取免费服务资格: '加WhatsApp獲取免費服務資格',
  // 評論相關
  精选好评直出睇完就知几得: '精選好評直出！睇完就知幾得！',
  // 評論1
  comment1Name: 'Amber Wang',
  comment1Text:
    '前幾個月有同大師兄喺youtube節目連線，佢有指導我一些小妙招。依家生意好轉了好多。想嚟感謝大師兄。',
  // 評論2
  comment2Name: '蘇小姐',
  comment2Text: '山凡師兄 五行手鏈佩戴了大約兩個月沒有見面半年的朋友話我面色氣息好轉 精氣神飽滿🙏',
  // 評論3
  comment3Name: 'Gnulnam Oh',
  comment3Text:
    '我之前個房都係五鬼位，訓入去成日失眠，周身唔舒服，個人身體比較敏感，所以搬去客廳訓，真係訓得好左，現在跟大師兄學風水先知係什麼問題。',
  // 評論4
  comment4Name: 'Kit Choi',
  comment4Text:
    '11月4日當天，心情有一些暴躁，有點火！但5號開始，心情好像輕鬆了，雖然在工作上一樣受到不公平的對待，但心態好像平靜了，吸一下就沒事了！感覺人好像輕鬆了一點！其他的，還在發掘中！',
  // 評論5
  comment5Name: 'Vienie Bebelove',
  comment5Text: '都要多謝你一聲，自送走童人，我覺得係好咗。',
  // 評論6
  comment6Name: '蔡小姐',
  comment6Text:
    '唔知有冇凝住，我帶咗心情好咗，少咗負面嘢諗，做事順利咗，還有之前經常帶住個泰國佛牌，講負面嘢亂發脾氣，經常擾亂我嘅同事，10月初突然話有膽石要去醫院割膽囊，足足一個月冇見，我就返咗一個月工冇休息，但係個人都好精神',
  // 評論7
  comment7Name: 'Sean Lee',
  comment7Text: '感謝感謝，做完後昨天我感覺有些神奇，個人真係好似輕鬆咗，心情都好咗。',
  // 評論8
  comment8Name: '張先生',
  comment8Text:
    '我愛易烊楓燧老師，專業，親切，幫我解決了人生迷茫解答準確率很高，很耐心，沒有知識優越感，強烈推薦。',
  // 表單相關
  立即获得免费服务资格: '立即獲得免費服務資格',
  告诉我们您的需求专业老师会在1个工作日为您服务: '告訴我們您的需求，專業老師會在1個工作日為您服務',
  您的姓名: '您的姓名',
  请填写您的姓名: '請填寫您的姓名',
  您的WhatsApp: '您的WhatsApp',
  请填写您的WhatsApp: '請填寫您的WhatsApp',
  您的电话电邮: '您的電話/電郵',
  请填写您的电话或电邮: '請填寫您的電話或電郵',
  选择您想咨询的老师: '選擇您想諮詢的老師',
  您想咨询的问题: '您想諮詢的問題',
  请简单描述您想咨询的问题: '請簡單描述您想諮詢的問題',
  请选择老师: '請選擇老師',
  立即提交: '立即提交',
  提交成功: '提交成功',
  提交失败: '提交失敗',
  我们会尽快与您联系: '我們會盡快與您聯繫',
  表单提交成功提示: '您嘅問題已提交成功，我哋會喺 1 個工作天內聯絡您，多謝您嘅耐心等候。',
  表单提交失败提示: '提交失敗，請您刷新頁面後重試。',
  // 老師選項
  teacher1Name: '易烊楓燧',
  teacher1Skills: '四柱八字命理、環境風水佈局、梅花易數、手相面相',
  teacher2Name: '趙振鴻',
  teacher2Skills: '八字命理、紫微斗數、掌面相、玄空風水',
  teacher3Name: '法銘道長',
  teacher3Skills: '天眼通、摸骨測字、祝由術',
  teacher4Name: '道元',
  teacher4Skills: '數字能量學、奇門術法、小六壬、高端風水佈局',
  // 底部相關
  联系我们: '聯繫我們',
  地址: '香港銅鑼灣告士打道262號中糧大廈20樓2003室',
  邮箱: 'chaonenglixueyuan@gmail.com',
  电话: '85284833986（超能力學院-山寺師兄）',
  营业时间: '工作日開放，10:00~19:00',
  品牌链接: '品牌鏈接',
  加入先知命局: '加入先知命局',
  免费领取每日运势及会员福利: '免費領取每日運勢及會員福利',
  LINE给你: 'LINE給你',
  FollowUs: 'Follow Us',
  // 合作媒體相關
  合作媒体: '合作媒體',
  '电视台/广播电台': '電視台/廣播電台',
  线上串流平台: '線上串流平台',
  新媒体全渠道曝光: '新媒體全渠道曝光',
  '报道+网媒': '報道+網媒',
  '名师匠心打造+权威媒体精选': '名師匠心出品+權威媒體精選',
  超多服务选择全都帮你拆解难题解决烦恼: '超多服務選擇，統統幫你拆解難題、解決煩惱！',
  超十万次真实案例全实录: '超十萬次鑑定實錄',
  版权信息: '© 2025 超能力學院｜All Rights Reserved.',
  名师匠心打造: '名師匠心出品',
  权威媒体精选: '權威媒體精選',
  超多服务选择: '超多服務選擇',
  精选好评直出: '精選好評直出',
  睇完就知幾得: '睇完就知幾得',
  TaoistFengsui: 'TaoistFengsui',
  '趙振鸿Master Chiu': '趙振鸿Master Chiu',
  法铭灵距离: '法銘靈距离',
  'Mr.DaoYuan': 'Mr.DaoYuan',
  立即下载: '立即下載',
};
